import { render, staticRenderFns } from "./AddressBar.vue?vue&type=template&id=4e20fcfb&scoped=true"
import script from "./AddressBar.vue?vue&type=script&lang=ts"
export * from "./AddressBar.vue?vue&type=script&lang=ts"
import style0 from "./AddressBar.vue?vue&type=style&index=0&id=4e20fcfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20fcfb",
  null
  
)

export default component.exports